import store from "../store";
import { uiActions } from "../store/ui/ui-slice";
import { defaultAxios } from "../utils/api/axios";
import { APIBaseUrl, APICustomServerUrl } from "../utils/constance";
import showToast from "../utils/toastUtil";

const dispatch = store.dispatch;

export const getAxios = async ({ url, params }) => {
  try {
    const data = await defaultAxios.get(url, { params });
    if (data && data?.success) {
      return data?.data || data;
    } else {
      return [];
    }
  } catch (error) {
    console.log("🚀 ~ getAxios ~ error:", error);
    return false;
  }
};

export const putAxios = async ({ url, payload }) => {
  dispatch(uiActions.setFormSubmitLoading(true));
  try {
    const data = await defaultAxios.put(url, payload);

    if (data) {
      showToast.success(data?.message || "Updated");
      return data?.data || data?.status;
    } else {
      showToast.error(data?.message || "Invalid data");
      return false;
    }
  } catch (error) {
    console.log("putAxios failed", error);
    return false;
  } finally {
    dispatch(uiActions.setFormSubmitLoading(false));
  }
};

export const patchAxios = async ({ url, payload }) => {
  dispatch(uiActions.setFormSubmitLoading(true));
  try {
    const data = await defaultAxios.patch(url, payload);

    if (data) {
      showToast.success(data?.message || "Updated");
      return data?.data || data?.status;
    } else {
      showToast.error(data?.message || "Invalid data");
      return false;
    }
  } catch (error) {
    console.log("putAxios failed", error);
    return false;
  } finally {
    dispatch(uiActions.setFormSubmitLoading(false));
  }
};

export const postAxios = async ({ url, payload }) => {
  dispatch(uiActions.setFormSubmitLoading(true));
  try {
    const data = await defaultAxios.post(url, payload);

    if (data && data?.success) {
      showToast.success(data?.message || "Success");
      return data?.data || data?.success;
    } else {
      showToast.error(data?.message || "Invalid data");
      return false;
    }
  } catch (error) {
    return false;
  } finally {
    dispatch(uiActions.setFormSubmitLoading(false));
  }
};

export const deleteAxios = async ({ url, payload }) => {
  dispatch(uiActions.setFormSubmitLoading(true));
  try {
    // const data = await defaultAxios.delete(url);

    const config = {
      baseURL: `${APIBaseUrl}`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      url,
      method: "delete",
      data: payload,
    };

    const data = await defaultAxios(config);

    if (data && data?.success) {
      showToast.success(data?.message || "deleted");
      return data?.success ?? true;
    } else {
      showToast.error(data?.message || "Invalid data");
      return false;
    }
  } catch (error) {
    console.log("deleteAxios failed", error);
    return false;
  } finally {
    dispatch(uiActions.setFormSubmitLoading(false));
  }
};

// custom axios url
// export const postCustomUrlAxios = async ({
//   subDomain,
//   url,
//   apptoken,
//   payload,
// }) => {
//   dispatch(uiActions.setFormSubmitLoading(true));
//   try {
//     const config = {
//       baseURL: `${APICustomServerUrl}${subDomain}/api/v1`,
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//         apptoken,
//       },
//       url,
//       method: "post",
//       data: payload,
//     };

//     const data = await defaultAxios(config);

//     if (data && data?.status) {
//       showToast.success(data?.message || "Success");
//       return data?.data;
//     } else {
//       showToast.error(data?.message || "Invalid data");
//       return false;
//     }
//   } catch (error) {
//     return false;
//   } finally {
//     dispatch(uiActions.setFormSubmitLoading(false));
//   }
// };
